import React, {useContext} from 'react';
import {Reducer} from 'hooks/Reducer';
import PropTypes from 'prop-types';

const createStore = (callback, initialState, name = 'store') => {
    const Store = (state, action) => callback(state, action);
    const StoreContext = React.createContext();

    const Provider = (props) => {
        let state = useReducer();

        return (
            <StoreContext.Provider value={state}>
                {props.children}
            </StoreContext.Provider>
        );
    }
    Provider.propTypes = {
        children: PropTypes.node
    }

    const useReducer = () => Reducer(Store, initialState);

    const wrapProvider = (ComponentToWrap) => {
        
        return (props) => <Provider>
            <ComponentToWrap {...props} />
        </Provider>;
    }

    const wrapConsumer = (ComponentToWrap) => {
        return (props) => {
            const store = useContext(StoreContext);
            const customProps = {};

            customProps[name] = store || useReducer();

            return <ComponentToWrap {...customProps} {...props} />;
        }
    }

    return {
        useReducer,
        wrapProvider,
        wrapConsumer
    }
}

export {
    createStore
};

